// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { DivWrapper } from "@awc/XDL/constants";
import { xScreen } from "@awc/XDL/Utilities";
import { headerStyles } from "@insite/content-library/Widgets/MyLists/MyListsHeader";
import { css } from "styled-components";

headerStyles.leftTopGridItem = {
    width: [12, 12, 12, 6, 6],
};

headerStyles.rightTopGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css``,
};

headerStyles.leftBottomGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        &:has(${DivWrapper}:empty) {
            display: none;
        }
    `,
};

headerStyles.rightBottomGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        &:has(${DivWrapper}:empty) {
            display: none;
        }
        ${DivWrapper} {
            display: flex;
            align-items: center;
            gap: 10px;

            ${xScreen("lte", "md")} {
                align-items: flex-end;
            }
            ${xScreen("lte", "xs")} {
                flex-direction: column;
            }
        }
    `,
};
